import React from 'react';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';
import { getBoardId } from '../../../../common/index.tsx';

export const LazyNextGenVelocityReport = lazyForPaint(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-next-gen-reports-velocity", jiraSpaEntry: "next-gen-reports-velocity" */ '@atlassian/jira-spa-apps-next-gen-reports-velocity/src/index-old.tsx'
		),
	),
);

type Props = RouteContext;

/** @deprecated delete file after all usages have been migrated to use entry points */
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ location, match }: Props) => (
	<LazyPage
		Page={LazyNextGenVelocityReport}
		pageId={`next-gen-reports-velocity-${getBoardId({ location, match })}`}
		shouldShowSpinner={false}
	/>
);
